<template>
  <div class="el-list names-list">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        class="base-border"
      >
        <h5 class="title-text">
          <span class="bold">{{ item.Letter }}</span>
        </h5>
        <div class="person-container">
          <p
            v-for="(child, childIndex) in item.Columns"
            :key="childIndex"
            class="list-item"
          >
            <span @click="viewColumn(child)">{{ child.Name }}</span>
            <img
              v-if="child.Locked && !isLogin"
              class="name-lock"
              src="../../assets/img/lock.png"
            >
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'PersonList',
  props: {
    list: {
      default: function () {
        return []
      },
      type: Array
    }
  },
  data () {
    return {
      currentPage: 1
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
      comeFromOldSystem: 'comeFromOldSystem'
    })
  },
  watch: {
    list () {
      this.sortList()
    }
  },
  created () {
    this.sortList()
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),
    sortList () {
      this.list.forEach(item => {
        item.Columns.sort((a, b) => a.Name.localeCompare(b.Name, 'zh-Hans-CN', { sensitivity: 'accent' }))
      })
    },
    viewColumn (item) {
      if (item.Locked && !this.isLogin) {
        this.loginShow()
      } else {
        let routes = this.$route.fullPath.split('/')
        if (this.comeFromOldSystem) {
          for (var i = routes.length; i < 4; i++) {
            routes.push(' ')
          }
          this.$router.push(routes.join('/') + '/' + item.Id)
        } else {
          this.$router.push('/column/' + routes[1] + '/' + item.Id)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/person-list.vue